import React, { Component } from "react";
import { SocialShare } from "@quintype/components";
import { CustomLink } from "../custom-link";
import get from "lodash/get";
import { Author } from "../basic/author.js";
import { getSocialShareTemplate } from "./social-share/get-social-template";
import PropTypes from "prop-types";
import {
  storyColor,
  sectionPath,
  getSocialShareProps,
  getSocialShareStyle,
  getHorizontalSocialShare
} from "../../utils";
import { AmazonPolly } from "../amazon-polly/amazon-polly";
import { SvgHandler } from "../svg-handler/svg-handler";
import liveblog from "../../../assets/icons/social/liveblog.svg";

class StoryHeaderCard extends Component {
  renderSocialShare() {
    const socialShareProps = getSocialShareProps(this.props.config, this.props.story);
    const horizontalSocialShareStyle = getHorizontalSocialShare(this.props.config);
    const socialShareStyle = getSocialShareStyle(this.props.config);
    const showHorizontal =
      !(this.props.textStory === "photo-priority") ||
      this.props.story["story-template"] === "review" ||
      !socialShareStyle.includes("vertical");

    return !showHorizontal ? null : (
      <div className={`story-byline__social-share horizontal-social-share-wrapper`}>
        <SocialShare template={getSocialShareTemplate(horizontalSocialShareStyle, false)} {...socialShareProps} />
      </div>
    );
  }

  getLiveBlogIcon(isClosed) {
    const storyTemplate = get(this.props, ["story", "story-template"]);

    return (
      storyTemplate === "live-blog" &&
      !isClosed && (
        <div className="live-story-wrapper">
          <SvgHandler width="8px" height="8px" viewBox="0 0 24 24" clazzName="liveblog" xlinkHref={liveblog} />
          <span className="live-story">live</span>
        </div>
      )
    );
  }

  render() {
    const color = storyColor(this.props.config, this.props.story);

    const sectionColor = {
      borderBottomColor: color
    };
    const authorsArray = get(this.props.story, ["authors"])
      ? get(this.props.story, ["authors"])
      : [
          {
            name: this.props.story["author-name"],
            id: this.props.story["author-id"]
          }
        ];
    const publishedTime = this.props.story["last-published-at"]
      ? this.props.story["last-published-at"]
      : this.props.story["first-published-at"];
    const { "is-closed": isClosed, "sponsored-by": sponsoredContent } = get(this.props, ["story", "metadata"], {});

    return (
      <header className="story-header">
        {sponsoredContent && (
          <p className="sponsored-story" data-sponsored-by="true">
            Sponsored by {sponsoredContent}
          </p>
        )}
        <CustomLink
          data-story-section-name="true"
          className="story-section"
          href={"/" + sectionPath(this.props.config, this.props.story.sections[0])}
          style={sectionColor}
        >
          {this.props.story.sections[0]["display-name"] || this.props.story.sections[0]["name"]}
        </CustomLink>
        <div data-testid="live-blog-icon">
          {this.getLiveBlogIcon(isClosed)}
          <h1 className="story-headline">
            <bdi dangerouslySetInnerHTML={{ __html: this.props.story.headline }} />
          </h1>
        </div>
        <p data-testid="story-summary" className="story-summary">
          <bdi dangerouslySetInnerHTML={{ __html: this.props.story.subheadline }} />
        </p>
        {/* Amazon Polly */}
        {this.props.showPolly && <AmazonPolly story={this.props.story} />}
        <div className="story-byline">
          <div className="story-byline__author_time">
            <Author
              config={this.props.config}
              authors={authorsArray}
              isLink
              showDateOnly
              date={publishedTime}
              textStory={this.props.textStory}
            />
          </div>
          {this.renderSocialShare()}
        </div>
      </header>
    );
  }
}

StoryHeaderCard.propTypes = {
  story: PropTypes.shape({
    "story-template": PropTypes.string,
    "author-name": PropTypes.string.isRequired,
    "last-published-at": PropTypes.string.isRequired,
    "first-published-at": PropTypes.string.isRequired,
    "author-id": PropTypes.number,
    headline: PropTypes.string,
    subheadline: PropTypes.string,
    sections: PropTypes.arrayOf(PropTypes.any)
  }),
  config: PropTypes.object,
  textStory: PropTypes.string,
  showPolly: PropTypes.bool
};

export { StoryHeaderCard };
